/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 29/07/13
 * Time: 17:10
 * To change this template use File | Settings | File Templates.
 */
angular.module('FlexyBeautyApp.services').
    factory('OrderProduct_Resource',["$resource","$location", function ($resource,$location)
    {
        var baseUrl = $location.protocol()  + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        var  resourceOrderS = $resource(baseUrl + 'rest/orderProducts/:id',{}, {
            query: { method: 'GET', isArray: true },
            get:   { method: 'GET' }
        });
        return resourceOrderS;
    }
    ]);

angular.module('FlexyBeautyApp.services').
factory('OrderProduct',["OrderProduct_Resource","ProductCategoryData","ProductData","OrderProductData","HumanResourceData",
        function (OrderProduct_Resource,ProductCategoryData,ProductData,OrderProductData,HumanResourceData)
    {
    //OrderProduct inherit from Activity
    var  OrderProduct = function (orderProductRes,isPreviousVersion)
    {
        this.id = null;
        this.label = null;
        this.price = 0;
        this.originalPrice =0;
        this.quantity = 0;
        this.product=null;
        this.order = null;
        this.version = null;
        this.loadObject(orderProductRes)
        this.loadRef();
        if (isPreviousVersion==undefined || !isPreviousVersion)//A previous version is not added to DATA
            OrderProductData.add(this);
    }

    OrderProduct.prototype.loadObject = function(object)
    {

        if (object!==undefined && object!=null)
        {
            if (!this.id)
                this.id=object.id;
            this.label=object.label;
            this.originalPrice=object.originalPrice;
            this.price=object.price;
            this.quantity=object.quantity;
            this.productId=object.productId;
            if (object.version)
                this.version = object.version;
        }
    };
    OrderProduct.prototype.loadRef = function()
    {
        if (this.productId)
            this.product = ProductData.getById(this.productId);
    };
    OrderProduct.prototype.copyDataTo = function(object)
    {

        object.id=this.id;
        object.label=this.label;
        object.originalPrice=this.originalPrice;
        object.price=this.price;
        object.quantity=this.quantity;

        if (this.product)
            object.productId = this.product.id;
        else
            object.productId = null;

        if (this.order)
            object.orderId = this.order.id;
        else
            object.orderId = null;
    };
    OrderProduct.prototype.getObjectResource = function()
    {
        var orderProductRes = new OrderProduct_Resource();
        this.copyDataTo(orderProductRes);
        return orderProductRes;
    };
    OrderProduct.prototype.setIdUsingObject = function(object)
    {
        this.id = object.id;
    };
    OrderProduct.prototype.setId = function(id)
    {
        this.id = id;
    };
    OrderProduct.prototype.getId = function()
    {
        return this.id;
    };
    OrderProduct.prototype.getLabel = function()
    {
        return this.label;
    };
    OrderProduct.prototype.getPrice = function()
    {
        return this.price;
    };

    return OrderProduct;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('OrderProductSrv',["$log","ServerSrv","DayData","OrderProductData","OrderProduct","ActivitySrv","OrderData",
        function ($log,ServerSrv,DayData,OrderProductData,OrderProduct,ActivitySrv,OrderData)
    {
        var  bpSrv = {};

        bpSrv.save =  function(orderProduct,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(bpSrv.saveSync, orderProduct, successFunction, errorFunction);
        };
        bpSrv.saveSync =  function(orderProduct,successFunction,errorFunction)
        {
            var bsRes = orderProduct.getObjectResource();
            bsRes.$save({},
                function (data) {
                    try {
                        // now we can set the id
                        orderProduct.setId(data.id);
                        if (!orderProduct.version || (data.version && data.version > orderProduct.version))
                            orderProduct.version = data.version;
                        //Add user action
                        //UserActionSrv.add(data.userAction);
                        //CallBack on success
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction !=undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );
        };
        bpSrv.updateLocally =  function(id,resource)
        {
            //not specific code to manage update/remove from order because this link is change only for a add or delete
            // (a orderProduct can't be moved to another order)
            //return ActivitySrv.updateLocally(resource);
            //TODO
        };
        bpSrv.removeLocally =  function(id,resource)
        {
            var orderProduct =  OrderProductData.getById(id)
            if (orderProduct!=null)
            {
                //remove from order
                if(orderProduct.order)
                    orderProduct.order.removeOrderProduct(orderProduct);
            }
            return orderProduct;
        };
        bpSrv.addLocally =  function(id,resource)
        {
            var orderProduct =  OrderProductData.getById(id)
            if (orderProduct!=null) //check if resource already exist inside index (current action could be a 'cancel')
                orderProduct.loadObject(resource);
            else
            {
                orderProduct = new OrderProduct(resource);
                orderProduct.id = id;
            }
            //add to order
            if(resource.orderId)
            {
                var order = OrderData.getById(resource.orderId);
                if (order)
                    order.addOrderProduct(orderProduct);
            }

            return orderProduct;
        };
        bpSrv.getPreviousVersionInstance =  function(resource)
        {
            var orderProduct =  new OrderProduct(resource,true);
            if(resource.orderId)
                orderProduct.order = OrderData.getById(resource.orderId);
            return orderProduct;

        };

        return bpSrv;
    }
    ]);

angular.module('FlexyBeautyApp.services').
    factory('OrderProductData',["$log", function ($log)
    {
        var  orderProductData =
        {
            indexOrderProducts : []
        };
        orderProductData.getById =  function(orderProductId)
        {
            for (var i=0;i<this.indexOrderProducts.length;i++)
                if (this.indexOrderProducts[i].id==orderProductId)
                    return this.indexOrderProducts[i];
            return null;
        }
        orderProductData.getIndexOf =  function(orderProduct)
        {
            if (orderProduct)
                return this.indexOrderProducts.indexOf(orderProduct);
            return -1;
        }
        orderProductData.getByIndex =  function(index)
        {
            if (index>=0 && index<this.indexOrderProducts.length)
                return this.indexOrderProducts[index];
            else
                return null;
        }
        orderProductData.add =  function(orderProduct)
        {
            this.indexOrderProducts.push(orderProduct);
            return this.indexOrderProducts.length-1;
        }
        orderProductData.clear =  function()
        {
            orderProductData.indexOrderProducts = [];
        }


        return orderProductData;
    }]);



// WEBPACK FOOTER //
// ./js/services/models/OrderProduct.js